<template>
  <v-card>
    <v-toolbar v-if="show_platform_dropdown" flat color="white" density="compact">
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.cluster"
          :items="advanced_search_models.cluster"
          @update:model-value="showRecords"
          :return-object="false"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('cluster') }}</span>
        </template>
      </v-autocomplete>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.unit"
          :items="advanced_search_models.unit"
          @update:model-value="showRecords"
          :return-object="false"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('unit') }}</span>
        </template>
      </v-autocomplete>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.root_asset_name"
          :items="advanced_search_models.root_asset_name"
          @update:model-value="showRecords"
          :return-object="false"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('root_asset_name') }}</span>
        </template>
      </v-autocomplete>
      <v-spacer/>
    </v-toolbar>
    <v-toolbar flat color="white" density="compact">
      <v-text-field
          density="compact"
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          color="primary"
          v-model="search"
          hide-details
          single-line
          flat
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('search') }}</span>
        </template>
      </v-text-field>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.priority"
          :items="['Prior 0','Prior 1','Prior 2','Prior 3']"
          @update:model-value="showRecords"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('priority') }}</span>
        </template>
      </v-autocomplete>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.company_priority"
          :items="['Critical','High','Medium','Low']"
          @update:model-value="showRecords"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('company_priority') }}</span>
        </template>
      </v-autocomplete>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.follow_up_workorder"
          :items="advanced_search_models.follow_up_workorder"
          @update:model-value="showRecords"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('follow_up_workorder') }}</span>
        </template>
      </v-autocomplete>
      <v-spacer/>
      <v-btn-toggle v-model="advanced_search.sece" density="compact" mandatory base-color="white" color="primary" rounded="xl" border @update:model-value="showRecords">
        <v-btn value="sece">
          {{ $store.getters.translate('sece') }}
        </v-btn>
        <v-btn value="non_sece">
          {{ $store.getters.translate('non_sece') }}
        </v-btn>
        <v-btn value="all">
          {{ $store.getters.translate('all') }}
        </v-btn>
      </v-btn-toggle>
      <v-menu>
        <template #activator="{ props }">
          <v-btn elevation="0" icon v-bind="props">
            <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="getClosedState" @click="setClosedState(false)">
            <template #prepend><PhEye size="24"/></template>
            <v-list-item-title class="sm-normal link ml-2">
              <span>{{ $store.getters.translate('show_closed') }}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-else @click="setClosedState(true)">
            <template #prepend><PhEyeSlash size="24"/></template>
            <v-list-item-title class="sm-normal link ml-2">
              <span>{{ $store.getters.translate('hide_closed') }}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div style="overflow-x: auto; width: 100%;">
      <v-data-table
          :headers="headers"
          :items="getRecords"
          class="elevation-1"
          @click:row="handleClick"
          :search="search"
          v-bind="footer_props"
          v-model:items-per-page="options.itemsPerPage"
          v-model:page="options.page"
          v-model="selected"
          :show-select="true"
          :group-by="[{key: 'article_id', order: 'asc'}]">
        <template #header.data-table-select>
          <v-chip variant="outlined" class="bulk-chip" rounded="pill" size="large" density="comfortable">
            <v-menu :disabled="selected.length === 0">
              <template #activator="{ props: menuProps, isActive }">
                <div class="chip-content">
                  <v-btn v-bind="menuProps" v-if="selected.length" icon class="arrow-btn" elevation="0">
                    <PhCaretUp v-if="isActive" size="20"/>
                    <PhCaretDown v-else size="20"/>
                  </v-btn>
                </div>
              </template>
              <v-list v-if="selected.length > 0">
                <v-list-item @click.stop="createBulkStandardDeviations">
                  <template #prepend><PhPlus size="24" color="primary"/></template>
                  <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("create") }} {{ selected.length }} {{ $store.getters.translate('standarddeviations') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-chip>
        </template>
        <template #group-header="{item, columns, toggleGroup, isGroupOpen}">
          <tr>
            <td :colspan="columns.length">
              <v-btn size="small" variant="flat" @click="toggleGroup(item)" :ref="'group-' + item.value" :data-open="isGroupOpen(item)">
                <v-icon :icon="isGroupOpen(item) ? '$expand' : '$next'" size="x-large"/>
                {{ item.items[0].raw.group_name }}
              </v-btn>
            </td>
          </tr>
        </template>
        <template #item.defect_status="{ item }">
          <template v-if="item.defect_status">
            {{ item.defect_status }}
          </template>
          <template v-else-if="item.closed">
            <v-icon color="green" size="8" class="ml-2 mr-2">mdi-circle</v-icon>
            <span class="sm-normal">Ready</span>
          </template>
          <template v-else>
            <v-icon color="red" size="8" class="ml-2 mr-2">mdi-circle</v-icon>
            <span class="sm-normal">Not Ready</span>
          </template>
        </template>
        <template #item.priority="{ item }">
          <PhNumberCircleZero v-if="item.priority === 'Prior 0'" color="red" size="24"/>
          <PhNumberCircleOne v-else-if="item.priority === 'Prior 1'" color="red" size="24"/>
          <PhNumberCircleTwo v-else-if="item.priority === 'Prior 2'" color="orange" size="24"/>
          <PhNumberCircleThree v-else-if="item.priority === 'Prior 3'" color="orange" size="24"/>
          <span v-else>Not set</span>
        </template>
        <template #item.deficiency_group="{ item }">
          {{ $store.getters.translate(item.deficiency_group) }}
        </template>
        <template #item.deviations_and_remarks="{ item }">
          {{ item.deviations_and_remarks }}
        </template>
        <template #item.actions="{ item }">
          <v-menu>
            <template #activator="{ props }">
              <v-btn elevation="0" icon v-bind="props">
                <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canEdit" @click="$emit('edit', item)">
                <template #prepend><PhPencilSimpleLine size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDelete" @click="deleteRecord(item.id)">
                <template #prepend><PhTrash size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </div>
  </v-card>
  <create-standard-deviations-bulk ref="create_standard_deviations" :selected="all_records.filter(record => selected.includes(record.id))" @refresh="uncheckAll"/>
</template>

<script>
import {useAbility} from "@casl/vue";
import helpFunctions from "../../plugins/helpFunctions";
import CreateStandardDeviationsBulk from "../../views/standarddeviations/Create";
import { PhChatTeardropText, PhDotsThreeVertical, PhEye, PhEyeSlash, PhNumberCircleOne, PhNumberCircleThree, PhNumberCircleTwo, PhNumberCircleZero, PhPencilSimpleLine, PhTrash, PhCaretUp, PhCaretDown, PhPlus } from "@phosphor-icons/vue";

export default {
  components: { CreateStandardDeviationsBulk, PhPlus, PhTrash, PhPencilSimpleLine, PhChatTeardropText, PhNumberCircleZero, PhEyeSlash, PhEye, PhDotsThreeVertical, PhNumberCircleThree, PhNumberCircleTwo, PhNumberCircleOne,  PhCaretUp, PhCaretDown },
  props: ["show_platform_dropdown"],
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      page: helpFunctions.pages.defects,
      headers: [],
      all_records: [],
      records: [],
      selected: [],
      options: helpFunctions.table_options,
      footer_props: helpFunctions.footer_props,
      search: '',
      advanced_search: {
        cluster: null,
        unit: null,
        root_asset_name: null,
        priority: null,
        company_priority: null,
        follow_up_workorder: null,
        sece: 'all',
      },
      advanced_search_models: {
        cluster: [],
        unit: [],
        root_asset_name: [],
        follow_up_workorder: [],
      },
    };
  },
  created() {
    this.headers = helpFunctions.composeTableHeaders(helpFunctions.headers.defects);
  },
  methods: {
    fillAdvancedSearchArrays() {
      this.all_records.forEach(record => {
        if(record.cluster && !this.advanced_search_models.cluster.includes(record.cluster)) {
          this.advanced_search_models.cluster.push(record.cluster);
        }
        if(record.unit && !this.advanced_search_models.unit.includes(record.unit)) {
          this.advanced_search_models.unit.push(record.unit);
        }
        if(record.root_asset_name && !this.advanced_search_models.root_asset_name.includes(record.root_asset_name)) {
          this.advanced_search_models.root_asset_name.push(record.root_asset_name);
        }
        if(record.follow_up_workorder && !this.advanced_search_models.follow_up_workorder.includes(record.follow_up_workorder)) {
          this.advanced_search_models.follow_up_workorder.push(record.follow_up_workorder);
        }
      });
      this.showRecords();
    },
    showRecords() {
      let sorted_array = this.all_records;
      if(this.options.hide_closed_defects) {
        sorted_array = sorted_array.filter((item) => !item.closed);
      }
      if(this.advanced_search.cluster) {
        sorted_array = sorted_array.filter(item => item.cluster === this.advanced_search.cluster);
      }
      if(this.advanced_search.unit) {
        sorted_array = sorted_array.filter(item => item.unit === this.advanced_search.unit);
      }
      if(this.advanced_search.root_asset_name) {
        sorted_array = sorted_array.filter(item => item.root_asset_name === this.advanced_search.root_asset_name);
      }
      if(this.advanced_search.priority) {
        sorted_array = sorted_array.filter(item => item.priority === this.advanced_search.priority);
      }
      if(this.advanced_search.company_priority) {
        sorted_array = sorted_array.filter(item => item.company_priority === this.advanced_search.company_priority);
      }
      if(this.advanced_search.follow_up_workorder) {
        sorted_array = sorted_array.filter(item => item.follow_up_workorder === this.advanced_search.follow_up_workorder);
      }
      if(this.advanced_search.sece === 'sece') {
        sorted_array = sorted_array.filter(item => item.sece);
      }
      else if(this.advanced_search.sece === 'non_sece') {
        sorted_array = sorted_array.filter(item => !item.sece);
      }
      this.records = sorted_array;
      this.openAll();
    },
    handleClick(event, row) {
      this.$emit('edit', row.item);
    },
    setClosedState(new_state) {
      this.options.hide_closed_defects = new_state;
    },
    async deleteRecord(id) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, id);
          this.$emit('refresh');
        }
      });
    },
    createBulkStandardDeviations() {
      this.$refs.create_standard_deviations.load();
    },
    uncheckAll() {
      this.selected = [];
    },
    openAll() {
      this.$nextTick(() => {
        Object.keys(this.$refs).forEach(k => {
          if (k.startsWith('group-') && this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
            this.$refs[k].$el.click();
          }
        });
      });
    },
  },
  computed: {
    getClosedState() {
      return this.options.hide_closed_defects;
    },
    getRecords() {
      if(this.records) {
        return this.records;
      }
      else {
        return [];
      }
    },
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
  },
  watch: {
    options: {
      handler() {
        this.showRecords();
      },
      deep: true,
    },
    advanced_search: {
      handler() {
        this.options.page = 1;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.bulk-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-color: rgba(var(--v-theme-primary), 0.3);
  padding: 0px !important;
}

.chip-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.arrow-btn {
  width: 36px;
  height: 36px;
  min-width: 0;
  background-color: transparent;
}
</style>